import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [subscribeMessage, setSubscribeMessage] = useState("");

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setSubscribeStatus("loading");
    try {
      const form = e.currentTarget as HTMLFormElement;
      const formData = new FormData(form);
      const honeypot = formData.get("website_alt") as string;
      if (honeypot && honeypot.trim() !== "") {
        setSubscribeStatus("success");
        setSubscribeMessage("感谢订阅！我们会将最新爆料发送到您的邮箱。");
        setEmail("");
        return;
      }
      const payload = new URLSearchParams();
      payload.append("email", email.trim());
      const response = await fetch("https://form.readdy.ai/api/form/submit", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === "OK") {
        setSubscribeStatus("success");
        setSubscribeMessage("感谢订阅！我们会将最新爆料发送到您的邮箱。");
        setEmail("");
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || "订阅失败，请稍后重试";
        setSubscribeStatus("error");
        setSubscribeMessage(errMsg);
      }
    } catch {
      setSubscribeStatus("error");
      setSubscribeMessage("网络错误，请稍后重试");
    }
  };

  const quickLinks = [
    { label: "网红黑料", path: "/category/wanghong-heiliao" },
    { label: "明星八卦", path: "/category/mingxing-bagua" },
    { label: "社会奇闻", path: "/category/shehui-qiwen" },
    { label: "关于我们", path: "/about" },
  ];

  return (
    <footer className="bg-background-100 mx-4 md:mx-8 mb-4 md:mb-8 rounded-2xl overflow-hidden" role="contentinfo">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h4 className="text-4xl md:text-5xl font-heading text-foreground-50 mb-3">
              订阅爆料
            </h4>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6 max-w-md">
              第一时间获取最新网红黑料与明星八卦，不错过任何一个大瓜。每日精选爆料直达您的邮箱。
            </p>
            <form onSubmit={handleSubscribe} id="subscribe-form" data-readdy-form="" className="flex flex-col sm:flex-row gap-3 max-w-lg">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute left-[-9999px] opacity-0 h-0 w-0 overflow-hidden pointer-events-none"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱地址"
                required
                className="flex-1 bg-transparent border-b border-foreground-600 focus:border-primary-500 outline-none px-0 py-2.5 text-sm text-foreground-200 placeholder:text-foreground-600 transition-colors"
              />
              <button
                type="submit"
                disabled={subscribeStatus === "loading"}
                className="px-6 py-2.5 bg-foreground-50 hover:bg-foreground-200 text-background-900 text-sm font-medium rounded-full flex items-center gap-2 cursor-pointer whitespace-nowrap transition-all duration-200 disabled:opacity-50"
              >
                {subscribeStatus === "loading" ? "订阅中..." : (
                  <>
                    立即订阅
                    <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
                  </>
                )}
              </button>
            </form>
            {subscribeStatus !== "idle" && (
              <p className={`mt-3 text-xs ${subscribeStatus === "success" ? "text-accent-400" : "text-primary-400"}`}>
                {subscribeMessage}
              </p>
            )}
          </div>

          <div className="md:col-span-3">
            <h5 className="text-sm font-medium text-foreground-300 mb-5">快速导航</h5>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-500"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h5 className="text-sm font-medium text-foreground-300 mb-5">联系方式</h5>
            <div className="space-y-4">
              <p className="text-sm text-foreground-500">
                <i className="ri-phone-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                400-911-8888
              </p>
              <p className="text-sm text-foreground-500">
                <i className="ri-mail-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                tips@911baoliao.com
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed">
                <i className="ri-map-pin-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                北京市朝阳区望京SOHO T3-A座 2801室
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/30 px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-6">
          <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-500" rel="nofollow">微博</a>
          <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-500" rel="nofollow">微信</a>
          <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer border-b border-transparent hover:border-foreground-500" rel="nofollow">抖音</a>
        </div>
        <p className="text-xs text-foreground-600">
          &copy; {new Date().getFullYear()} 911爆料网 版权所有
        </p>
        <div className="flex items-center gap-4">
          <a href="/about" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
            隐私政策
          </a>
          <a href="/about" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
            用户协议
          </a>
        </div>
      </div>
    </footer>
  );
}